<template>
  <div>
    <div class="logo" :style="logoStyle"></div>
    <v-navigation-drawer fixed :clipped="true" app disable-resize-watcher stateless :value="sidebarVisible" width="220" style="margin-top: 48px;">
      <v-list class="sideBar">
        <v-list-item-group>
          <v-list-item v-for="(item, i) in menuItems" :key="i">
            <v-list-item-icon>
              <v-icon v-text="item.icon" color="#455A64" @click="selectMenu(item)"/>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="$t(item.text)" @click="selectMenu(item)" :style="currentItemKey === item.key ? 'font-weight: bold;' : ''"/>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      date: new Date()
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('session/logout')
      this.$store.dispatch('page/setSidebarItem', {})
      this.$router.push({name: 'Login'})
    },
    selectMenu (menu) {
      if (menu.key === 'logout') {
        this.logout()
      } else if (menu.routerName) {
        this.$router.push({name: menu.routerName}).catch(() => {})
      } else {
        this.$router.push({name: 'Dashboard'})
      }
    }
  },
  computed: {
    sidebarVisible: function () {
      return this.$store.state.sidebar.visible
    },
    menuItems: function () {
      // let roles = this.$store.state.session.roles
      // console.log('Filter sidebar items by roles: ' + roles)
      return this.$store.state.sidebar.items.filter(i => (!i.roles || this.$store.getters['session/hasRole'](i.roles)) && !(i.excludeRoles && !this.$store.getters['session/hasNotRole'](i.excludeRoles)))
      // return this.$store.state.sidebar.items
    },
    logoStyle: function () {
      return this.$store.state.sidebar.visible ? 'left: 10px;' : 'left: -250px;'
    },
    currentItemKey: function () {
      return this.$store.state.page.sidebarItemKey
    }
  }
}
</script>

<style scoped>
  .v-navigation-drawer {
    height: calc(100vh - 48px) !important;
    max-height: calc(100vh - 48px) !important;
  }
  div.logo {
    background-color: white;
    position: fixed;
    left: 0;
    top: calc(100vh - 90px);
    width: 210px;
    height: 70px;
    z-index: 10;
    background-image: url(/static/logo.png);
    background-repeat: no-repeat;
    background-position: 22px 8px;
    background-size: 150px;
    border-right: 1px solid rgba(0,0,0,.12);
    transition: left .2s cubic-bezier(.4,0,.2,1);
    vertical-align: middle;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue